var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            [
              _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end",
                  attrs: { md: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.redirectToStore },
                    },
                    [_vm._v(" Visit Website ")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: {
                        variant: "primary",
                        to: "/servicetemplates/add",
                      },
                    },
                    [_vm._v(" Add Templatess ")]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "my-1",
                  attrs: { cols: "12", md: "2", sm: "2" },
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-col", { staticClass: "my-1", attrs: { md: "4", sm: "8" } }),
              _c(
                "b-col",
                {
                  staticClass: "my-1 d-flex justify-content-end",
                  attrs: { md: "6" },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-danger" },
                      on: { click: _vm.clearFilters },
                    },
                    [_vm._v(" Clear Filters ")]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      items: _vm.filteredService,
                      fields: _vm.fields,
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "sort-changed": _vm.onSortChanged,
                      filtered: _vm.onFiltered,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "head(orderName)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Template Name")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Search by Name",
                                      size: "sm",
                                    },
                                    on: { input: _vm.filterTable },
                                    model: {
                                      value: _vm.columnFilters.orderName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "orderName",
                                          $$v
                                        )
                                      },
                                      expression: "columnFilters.orderName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "head(orderDescription)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Description")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Search by Description",
                                      size: "sm",
                                    },
                                    on: { input: _vm.filterTable },
                                    model: {
                                      value: _vm.columnFilters.orderDescription,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "orderDescription",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "columnFilters.orderDescription",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "head(budget)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Budget")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Search by Budget",
                                      size: "sm",
                                      type: "number",
                                    },
                                    on: { input: _vm.filterTable },
                                    model: {
                                      value: _vm.columnFilters.budget,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "budget",
                                          $$v
                                        )
                                      },
                                      expression: "columnFilters.budget",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "head(estimatedDuration)",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column" },
                                [
                                  _c("span", [_vm._v("Estimated Duration")]),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    attrs: {
                                      placeholder: "Search by Duration",
                                      size: "sm",
                                      type: "number",
                                    },
                                    on: { input: _vm.filterTable },
                                    model: {
                                      value:
                                        _vm.columnFilters.estimatedDuration,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.columnFilters,
                                          "estimatedDuration",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "columnFilters.estimatedDuration",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    variant: "link",
                                    "toggle-class": "text-decoration-none",
                                    "no-caret": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("feather-icon", {
                                              staticClass:
                                                "text-body align-middle mr-25",
                                              attrs: {
                                                icon: "MoreVerticalIcon",
                                                size: "16",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        to: _vm.getEditUrl(data.item.id),
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "Edit2Icon" },
                                      }),
                                      _c("span", [_vm._v("Edit")]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeTemplate(
                                            data.item.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "TrashIcon" },
                                      }),
                                      _c("span", [_vm._v("Delete")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1591808298
                    ),
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-center mb-1" },
                    [
                      _vm.loading
                        ? _c("b-spinner", {
                            staticStyle: { width: "3rem", height: "3rem" },
                            attrs: {
                              variant: "success",
                              label: "Spinning",
                              block: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }